import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
const Header = styled.div`
  border: 1px solid black;
  background-color: ${({ theme }) => theme.main};
  padding: 0.5em;
  .mdl-textfield {
    padding: 4px 0;
  }
  input {
    font-size: 1.5em;
  }
`
const Content = styled.div`
  position: relative;
  padding: 0.5em;
  border: 1px solid black;
  border-top: none;
`
const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
  padding: 0 0.5em;
  background-color: ${({ theme }) => theme.muted};
`

export default function Panel({
  header,
  children,
  actions,
  contentStyle,
  ...restProps
}) {
  return (
    <Container {...restProps}>
      {header &&
        <Header>
          {header}
        </Header>}
      {children &&
        <Content style={contentStyle}>
          {children}
        </Content>}
      {actions &&
        <ActionContainer>
          {actions}
        </ActionContainer>}
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/Units/components/Panel.js